var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"disabled":_vm.props.disabled,"to":{ name: _vm.props.to },"loading":_vm.props.loading,"color":_vm.props.color,"elevation":"0","small":"","height":_vm.props.height},on:{"click":_vm.props.click}},[_c('v-icon',{class:`${_vm.props.iconClass}`},[_vm._v(_vm._s(_vm.props.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }